// Vuex
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

// Modules
import * as user from '@/store/modules/user';
import * as room from '@/store/modules/room';

export default new Vuex.Store({
    modules: {
        room,
        user,
    },
    state: {
        loading: false,
    },
    mutations: {
        /**
         * Set the loading state
         * @param {object} state - The state object
         * @param {Boolean} isLoading - Is it loading
         */
        SET_LOADING(state, isLoading) {
            state.loading = isLoading;
        },
    },
    getters: {
        /**
         * Get a rule
         */
        GET_RULE: (state) => {
            const rules = require('@/assets/rules.json');
            const rule = rules[state.room.latestCard.value];

            if (rule) {
                const r = (str) =>
                    str.replaceAll('{player}', state.room.turn.name);

                return {
                    title: r(rule.title),
                    description: r(rule.description),
                };
            } else {
                return '';
            }
        },
    },
    actions: {},
});
